import Vue from 'vue'

import App from './App.vue'
import  router  from './router'
import ElementUI from 'element-ui';
import '@/styles/index.scss' // global css
import store from './store'
import messages from './locale/index'
// 导入i18n
import VueI18n from 'vue-i18n';
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale:  localStorage.getItem('lang') || 'zh', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages,
  silentFallbackWarn: true,
});


import storage from '@/utils/storage.js';
Vue.prototype.$storage= storage

import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
